import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";

const StockGraphs = () => {
  const [chartData, setChartData] = useState(null);
  const [visiblePharmacies, setVisiblePharmacies] = useState([]);
  const [debug, setDebug] = useState({});

  useEffect(() => {
    const fetchAndProcess = async () => {
      const groupId = localStorage.getItem("userId");
      const membersRaw = localStorage.getItem("members");
      const members = JSON.parse(membersRaw || "[]");
      const token = localStorage.getItem("authToken"); // ✅ NEW

      console.log("🔍 DEBUG START");
      console.log("groupId:", groupId);
      console.log("members raw:", membersRaw);
      console.log("members parsed:", members);
      console.log("token:", token); // ✅ NEW

      if (!groupId) {
        console.error("Missing groupId");
        setChartData({ shelfData: {}, expiryData: {}, pharmacies: [] });
        return;
      }

      if (!token) {
        console.error("❌ Missing auth token");
        setChartData({ shelfData: {}, expiryData: {}, pharmacies: [] });
        return;
      }

      try {
        // ✅ FIXED FETCH (AUTH ADDED)
        const res = await fetch(
          `https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`,
          {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );

        if (!res.ok) throw new Error("API failed");

        const data = await res.json();

        console.log("📦 Inventory sample:", data.slice(0, 5));
        console.log("📦 Total inventory count:", data.length);

        const now = new Date();

        const memberNames = members.map(m => m.pharmacyName);
        const inventoryNames = data.map(d => d.pharmacyName).filter(Boolean);

        console.log("🏥 memberNames:", memberNames);
        console.log("🏥 inventoryNames:", inventoryNames.slice(0, 10));

        const pharmacies = [...new Set([...memberNames, ...inventoryNames])].sort();

        console.log("🏥 FINAL pharmacies:", pharmacies);

        const shelfData = {};
        const expiryData = {};

        pharmacies.forEach(name => {
          shelfData[name] = Array(53).fill(0);
          expiryData[name] = Array(53).fill(0);
        });

        let usedItems = 0;

        for (const item of data) {
          if ((item.status || "").toLowerCase().trim() !== "on shelf") continue;

          const phName = item.pharmacyName;

          if (!phName || !shelfData[phName]) {
            console.log("⚠️ Skipped item (no match):", item.pharmacyName);
            continue;
          }

          usedItems++;

          const value = ((parseInt(item.balance || 0)) * (item.price || 0)) / 100;

          const fs = item.firstScanned ? new Date(item.firstScanned) : null;
          const ed = item.expiryDate ? new Date(item.expiryDate) : null;

          const shelfWeeks = fs
            ? Math.min(52, Math.floor((now - fs) / (1000 * 60 * 60 * 24 * 7)))
            : 0;

          const expiryWeeks = ed
            ? Math.max(0, Math.min(52, Math.floor((ed - now) / (1000 * 60 * 60 * 24 * 7))))
            : 52;

          shelfData[phName][shelfWeeks] += value;
          expiryData[phName][expiryWeeks] += value;
        }

        console.log("✅ Items used in graph:", usedItems);

        setDebug({
          membersCount: members.length,
          inventoryCount: data.length,
          pharmaciesCount: pharmacies.length,
          usedItems
        });

        setChartData({ shelfData, expiryData, pharmacies });
        setVisiblePharmacies(pharmacies);

      } catch (err) {
        console.error("Error fetching inventory:", err);
        setChartData({ shelfData: {}, expiryData: {}, pharmacies: [] });
      }
    };

    fetchAndProcess();
  }, []);

  if (!chartData) return <div>Loading graphs...</div>;

  return (
    <div style={{ padding: '20px' }}>

      <div style={{
        background: "#fff3cd",
        padding: "10px",
        marginBottom: "10px",
        border: "1px solid #ffeeba",
        fontSize: "12px"
      }}>
        <b>DEBUG:</b><br/>
        Members: {debug.membersCount || 0} <br/>
        Inventory items: {debug.inventoryCount || 0} <br/>
        Pharmacies detected: {debug.pharmaciesCount || 0} <br/>
        Items used in graph: {debug.usedItems || 0}
      </div>

      {chartData.pharmacies.length === 0 && (
        <div>No data available (see debug above + console)</div>
      )}

      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {chartData.pharmacies.map(ph => (
          <button
            key={ph}
            onClick={() => setVisiblePharmacies(prev =>
              prev.includes(ph)
                ? prev.filter(p => p !== ph)
                : [...prev, ph]
            )}
            style={{
              padding: "4px 8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: visiblePharmacies.includes(ph) ? "#4A90E2" : "#eee",
              color: visiblePharmacies.includes(ph) ? "white" : "black",
              cursor: "pointer",
              fontSize: "11px"
            }}
          >
            {ph}
          </button>
        ))}
      </div>

      <ReactECharts
        option={{
          title: { text: 'Stock value by time on shelves' },
          xAxis: { type: 'category', data: Array.from({ length: 53 }, (_, i) => i) },
          yAxis: { type: 'value' },
          series: chartData.pharmacies.map(ph => ({
            name: ph,
            type: 'line',
            data: chartData.shelfData[ph]
          }))
        }}
        style={{ height: "400px" }}
      />
    </div>
  );
};

export default StockGraphs;